import React, { useState, useEffect, useCallback } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link, useLocation } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";
import { CgFileDocument } from "react-icons/cg";

const navIconStyle = { marginBottom: "2px" };
const SCROLL_THRESHOLD = 20;

const NAV_ITEMS = [
  { path: "/", icon: AiOutlineHome, label: "Home" },
  { path: "/about", icon: AiOutlineUser, label: "About" },
  { path: "/project", icon: AiOutlineFundProjectionScreen, label: "Projects" },
  { path: "/resume", icon: CgFileDocument, label: "Resume" },
];

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const location = useLocation();

  const isActive = useCallback(
    (path) => location.pathname === path,
    [location.pathname],
  );

  useEffect(() => {
    const scrollHandler = () => {
      updateNavbar(window.scrollY >= SCROLL_THRESHOLD);
    };

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const handleToggleClick = useCallback(() => {
    updateExpanded((prev) => (prev ? false : "expanded"));
  }, []);

  const handleNavLinkClick = useCallback(() => {
    updateExpanded(false);
  }, []);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <img
            src={`${process.env.PUBLIC_URL}/favicon.png`}
            className="img-fluid logo"
            alt="brand"
          />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={handleToggleClick}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            {NAV_ITEMS.map(({ path, icon: Icon, label }) => (
              <Nav.Item key={path}>
                <Nav.Link
                  as={Link}
                  to={path}
                  onClick={handleNavLinkClick}
                  className={isActive(path) ? "nav-link-active" : ""}
                >
                  <Icon style={navIconStyle} /> {label}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default React.memo(NavBar);
